import { render, staticRenderFns } from "./sourseListEdu.vue?vue&type=template&id=3d38d53e&scoped=true"
import script from "./sourseListEdu.vue?vue&type=script&lang=js"
export * from "./sourseListEdu.vue?vue&type=script&lang=js"
import style0 from "./sourseListEdu.vue?vue&type=style&index=0&id=3d38d53e&scoped=true&lang=scss"
import style1 from "./sourseListEdu.vue?vue&type=style&index=1&id=3d38d53e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38d53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d38d53e')) {
      api.createRecord('3d38d53e', component.options)
    } else {
      api.reload('3d38d53e', component.options)
    }
    module.hot.accept("./sourseListEdu.vue?vue&type=template&id=3d38d53e&scoped=true", function () {
      api.rerender('3d38d53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/components/sourseListEdu.vue"
export default component.exports